import { render, staticRenderFns } from "./otherPayment.vue?vue&type=template&id=8ca0a856&scoped=true"
import script from "./otherPayment.vue?vue&type=script&lang=js"
export * from "./otherPayment.vue?vue&type=script&lang=js"
import style0 from "./otherPayment.vue?vue&type=style&index=0&id=8ca0a856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca0a856",
  null
  
)

export default component.exports